import axios from 'axios';
import { STORE } from 'const/local-storage';
import { PUBLIC_DATA } from 'const/session-storage';
import posthog from 'posthog-js';

import config from '../config/config';
import baseUrlUtil from '../util/base-url-util';

const getStorePublicDetails = async () => {
  const publicDateString = sessionStorage.getItem(PUBLIC_DATA);
  if (publicDateString) {
    return JSON.parse(publicDateString);
  }
  const apiBaseUrl = config.publicApi.enabled ? config.publicApi.url : config.api.url;

  try {
    const response = await axios.get(`${apiBaseUrl}/api/public/`, {
      params: {
        baseUrl: baseUrlUtil.getBaseUrl()
      }
    });

    const storeData = response.data.data;
    localStorage.setItem(STORE, JSON.stringify(storeData));
    sessionStorage.setItem(PUBLIC_DATA, JSON.stringify(storeData));

    return storeData;
  } catch (e) {
    // @ts-ignore
    // eslint-disable-next-line no-undef
    posthog?.capture('getStorePublicDetailsFailed', { error: e.toJSON(), version: VERSION });
    console.warn('Error fetching store details:', e);
    const storeData = localStorage.getItem(STORE);
    if (storeData) {
      return JSON.parse(storeData);
    }
  }
};

export default getStorePublicDetails;
